import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import { AuthAPI } from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      setUser(await AuthAPI.me());
    } catch (e) {
      if (e?.response?.status !== 401) console.error('[auth] session check failed', e);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Returning from OAuth: AuthCallback exchanges the session_id first, skip /me here.
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = useCallback(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/workspace';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  }, []);

  const loginWithPassword = useCallback(async (email, password) => {
    const u = await AuthAPI.login(email, password);
    setUser(u);
    return u;
  }, []);

  const logout = useCallback(async () => {
    try { await AuthAPI.logout(); } catch (e) { console.error('[auth] logout request failed', e); }
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({ user, setUser, loading, login, loginWithPassword, logout, checkAuth }),
    [user, loading, login, loginWithPassword, logout, checkAuth],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
